import FingerprintJS from '@fingerprintjs/fingerprintjs'

// 指纹代理只初始化一次，避免每次登录重复加载采集器。
const fingerprintPromise = FingerprintJS.load()
export const LOGIN_FINGERPRINT_KEY = 'login_fingerprint'
export const FINGER_DEVICE_KEY = 'finger_device'
let cachedFingerprintData = null
let cachedFingerDevice = null

export async function getBrowserFingerprintData(forceRefresh = false) {
  if (cachedFingerprintData && !forceRefresh) {
    return cachedFingerprintData
  }

  const fingerprint = await fingerprintPromise
  const result = await fingerprint.get()
  cachedFingerprintData = {
    fingerprint: result.visitorId,
    fingerprintDetail: result.components
  }

  return cachedFingerprintData
}

export async function getBrowserFingerprint(forceRefresh = false) {
  const { fingerprint } = await getBrowserFingerprintData(forceRefresh)

  return fingerprint
}

export async function getFingerDevice() {
  if (cachedFingerDevice) return cachedFingerDevice
  const userAgentData = navigator.userAgentData
  if (userAgentData && typeof userAgentData.getHighEntropyValues === 'function') {
    const deviceInfo = await userAgentData.getHighEntropyValues([
      'architecture',
      'bitness',
      'platformVersion'
    ])

    cachedFingerDevice = `${deviceInfo.platform} ${deviceInfo.architecture}_${deviceInfo.bitness} ${deviceInfo.platformVersion}`
  } else {
    cachedFingerDevice = `${navigator.platform || ''} ${navigator.userAgent || ''}`.trim()
  }

  localStorage.setItem(FINGER_DEVICE_KEY, cachedFingerDevice)
  return cachedFingerDevice
}

export function getStoredFingerprintHeaders() {
  return {
    fingerprint: getLoginFingerprint() || '',
    'Finger-Device': localStorage.getItem(FINGER_DEVICE_KEY) || `${navigator.platform || ''} ${navigator.userAgent || ''}`.trim()
  }
}

export function getLoginFingerprint() {
  return localStorage.getItem(LOGIN_FINGERPRINT_KEY)
}

export function saveLoginFingerprint(fingerprint) {
  localStorage.setItem(LOGIN_FINGERPRINT_KEY, fingerprint)
}

export function clearLoginFingerprint() {
  localStorage.removeItem(LOGIN_FINGERPRINT_KEY)
  localStorage.removeItem(FINGER_DEVICE_KEY)
  cachedFingerDevice = null
}
